import { ENDPOINTS } from 'src/constants/endpoints'

import { http } from 'src/interfaces/http'

interface IRefreshTokenResponse {
  access_token: string
}

export const refreshToken = async (): Promise<string> => {
  const { data } = await http.get<IRefreshTokenResponse>(
    ENDPOINTS.auth.refresh,
    { withCredentials: true },
  )
  return data.access_token
}
